<template>
    <div :class="cardClass">
        <div class="external-recipient-card__body">
            <p class="external-recipient-card__name">{{ displayName }}</p>
            <p class="external-recipient-card__status">{{ statusLabel }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            recipient: {
                type: Object,
                required: true,
            },
        },

        computed: {
            cardClass() {
                return {
                    card: true,
                    'card__fixed-hight': true,
                    'card--is-standalone': true,
                    'external-recipient-card': true,
                }
            },
            displayName() {
                const contact = this.recipient.data && this.recipient.data.contactInfo
                if (contact && (contact.firstName || contact.lastName)) {
                    return [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim()
                }
                return this.recipient.providerNpi ? `NPI ${this.recipient.providerNpi}` : 'Provider'
            },
            statusLabel() {
                const labels = {
                    PENDING: 'Outreach pending',
                    INVITED: 'Invited',
                    CLAIMED: 'Joined',
                    FAILED: 'Outreach failed',
                    NO_CONTACT: 'No contact info',
                }
                return labels[this.recipient.status] || this.recipient.status
            },
        },
    }
</script>

<style scoped lang="scss">
    .external-recipient-card {
        min-height: 120px;

        &__body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px;
            text-align: center;
        }

        &__name {
            font-weight: 500;
            color: #333;
            margin: 0 0 8px;
            font-size: 16px;
        }

        &__status {
            font-size: 14px;
            color: #666;
            margin: 0;
        }
    }
</style>
